module.exports = __webpack_public_path__ + "c8b629f97e6503e29266b6b7e41db714.png";